import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/models/entities/usuario';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { TramoLicitacion } from 'src/app/models/entities/tramo-licitacion';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { TramoService } from 'src/app/services/tramo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { AlertasService } from 'src/app/services/alertas.service';


@Component({
  selector: 'edicion-incidencia-obra',
  templateUrl: './edicion-incidencia-obra.component.html',
  styleUrls: ['./edicion-incidencia-obra.component.scss']
})
export class EdicionIncidenciaObraComponent implements OnInit {

  public es: any;
  public tramoLicitacionForm: FormGroup;
  public date: Date = new Date();
  public usuarioEnSesion: Usuario;
  public catEmpresas$: Observable<ElementoCatalogo[]>;
  public keyObra: string = '';
  public keyTramoLicitacion: string = '';
  public tramoLicitacion: TramoLicitacion;
  public dataLoaded: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private catalogoService: CatalogoService,
    private activatedRoute: ActivatedRoute,
    private facadeSesionService: FacadeSesionService,
    private tramoLicitacionService: TramoService,
    private alertasService: AlertasService,
    private router: Router
  ) { }

  ngOnInit() {
    this.obtenerIncidenciaObra();
  }

  public async obtenerIncidenciaObra() {
    this.keyTramoLicitacion = this.activatedRoute.snapshot.params.keyTramoLicitacion;
    this.keyObra = this.activatedRoute.snapshot.params.keyObra;
    this.facadeSesionService.usuarioEnSesionService.obtenerUsuario().subscribe(
      (usuarioSesionDTO: UsuarioSesionDTO) => this.usuarioEnSesion = usuarioSesionDTO.usuario
    );
    this.cargarIdiomaCalendario();
    this.obtenerCatEmpresas();
    this.tramoLicitacion = await this.tramoLicitacionService.findByKey(this.keyTramoLicitacion).pipe(take(1)).toPromise();
    this.inicializarForm();
  }

  private inicializarForm(): void {
    this.tramoLicitacionForm = this.formBuilder.group({
      keyObra: new FormControl(this.keyObra),
      descripcionContrato: new FormControl(this.tramoLicitacion.descripcionContrato, [Validators.required]),
      numContrato: new FormControl(this.tramoLicitacion.numContrato, [Validators.required]),
      fechaInicio: new FormControl(new Date(this.tramoLicitacion.fechaInicio), [Validators.required]),
      fechaFin: new FormControl(new Date(this.tramoLicitacion.fechaFin), [Validators.required]),
      longitudTotal: new FormControl(this.tramoLicitacion.longitudTotal, [Validators.required]),
      keyCatEmpresa: new FormControl(this.tramoLicitacion.keyCatEmpresa, [Validators.required, this.validateId]),
      importeContrato: new FormControl(this.tramoLicitacion.importeContrato, [Validators.required]),
      montoAnticipo: new FormControl(this.tramoLicitacion.montoAnticipo, [Validators.required]),
      numLicitacion: new FormControl(this.tramoLicitacion.numLicitacion, [Validators.required]),
      fechaPublicacion: new FormControl(new Date(this.tramoLicitacion.fechaPublicacion), [Validators.required]),
      fechaJuntaAclaracion: new FormControl(new Date(this.tramoLicitacion.fechaJuntaAclaracion), [Validators.required]),
      fechaVisitaSitio: new FormControl(new Date(this.tramoLicitacion.fechaVisitaSitio), [Validators.required]),
      fechaApertura: new FormControl(new Date(this.tramoLicitacion.fechaApertura), [Validators.required]),
      fechaFallo: new FormControl(new Date(this.tramoLicitacion.fechaFallo), [Validators.required]),
      afiliadaCMIC: new FormControl(this.tramoLicitacion.afiliadaCMIC),
      avanceFisicoProgramado: new FormControl(this.tramoLicitacion.avanceFisicoProgramado, [Validators.required]),
      avanceFisicoReal: new FormControl(this.tramoLicitacion.avanceFisicoReal, [Validators.required]),
      avanceFisicoAtraso: new FormControl(this.tramoLicitacion.avanceFisicoAtraso, [Validators.required]),
      avanceFinancieroProgramado: new FormControl(this.tramoLicitacion.avanceFinancieroProgramado, [Validators.required]),
      avanceFinancieroReal: new FormControl(this.tramoLicitacion.avanceFinancieroReal, [Validators.required]),
      avanceFinancieroAtraso: new FormControl(this.tramoLicitacion.avanceFinancieroAtraso, [Validators.required])
    });
    this.dataLoaded = true;
  }

  public cargarIdiomaCalendario() {
    this.es = {
      firstDayOfWeek: 0,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'dd/MM/yyyy HH:mm',
      weekHeader: 'Wk'
    };
  }

  public obtenerCatEmpresas(): void {
    this.catEmpresas$ = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.EMPRESAS).pipe(take(1));
  }

  public actualizarIncidenciaObra(): Promise<TramoLicitacion> {
    return new Promise((resolve, reject) => {
      let tramoLicitacion: TramoLicitacion = this.crearModelo();
      if (tramoLicitacion) {
        resolve(tramoLicitacion);
        this.tramoLicitacionService.update(this.keyTramoLicitacion, tramoLicitacion).then(
          () => {
            this.alertasService.mostrarAlerta('success', "Datos actualizados correctamente.");
            this.router.navigate(['/tablero/admon-tramo-licitacion', this.keyObra], { skipLocationChange: true });
          }
        );
      }
      return reject("No se puede generar modelo")
    });
  }

  public crearModelo(): TramoLicitacion {
    return {
      keyObra: this.keyObra,
      descripcionContrato: this.tramoLicitacionForm.get('descripcionContrato').value,
      numContrato: this.tramoLicitacionForm.get('numContrato').value,
      numLicitacion: this.tramoLicitacionForm.get('numLicitacion').value,
      afiliadaCMIC: this.tramoLicitacionForm.get('afiliadaCMIC').value,
      avanceFinancieroAtraso: this.tramoLicitacionForm.get('avanceFinancieroAtraso').value,
      avanceFinancieroReal: this.tramoLicitacionForm.get('avanceFinancieroReal').value,
      avanceFinancieroProgramado: this.tramoLicitacionForm.get('avanceFinancieroProgramado').value,
      avanceFisicoAtraso: this.tramoLicitacionForm.get('avanceFisicoAtraso').value,
      avanceFisicoProgramado: this.tramoLicitacionForm.get('avanceFisicoProgramado').value,
      avanceFisicoReal: this.tramoLicitacionForm.get('avanceFisicoReal').value,
      importeContrato: this.tramoLicitacionForm.get('importeContrato').value,
      longitudTotal: this.tramoLicitacionForm.get('longitudTotal').value,
      montoAnticipo: this.tramoLicitacionForm.get('montoAnticipo').value,
      keyUsuario: this.usuarioEnSesion.key,
      keyCatEmpresa: this.tramoLicitacionForm.get('keyCatEmpresa').value,
      fechaActualizacion: (this.date).getTime(),
      fechaCreacion: new Date(this.tramoLicitacion.fechaCreacion).getTime(),
      fechaInicio: (this.tramoLicitacionForm.get('fechaInicio').value as Date).getTime(),
      fechaFin: (this.tramoLicitacionForm.get('fechaFin').value as Date).getTime(),
      fechaPublicacion: (this.tramoLicitacionForm.get('fechaPublicacion').value as Date).getTime(),
      fechaJuntaAclaracion: (this.tramoLicitacionForm.get('fechaJuntaAclaracion').value as Date).getTime(),
      fechaVisitaSitio: (this.tramoLicitacionForm.get('fechaVisitaSitio').value as Date).getTime(),
      fechaApertura: (this.tramoLicitacionForm.get('fechaApertura').value as Date).getTime(),
      fechaFallo: (this.tramoLicitacionForm.get('fechaFallo').value as Date).getTime()
    }
  }

  public validarAfiliadaCMIC(checkValue: boolean) {
    if (!checkValue) {
      this.tramoLicitacionForm.get('afiliadaCMIC').setValue(0);
    }
  }

  public getErrorLicitacion(controlName: string): string {
    let error = '';
    const control = this.tramoLicitacionForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  private validateId(control: AbstractControl) {
    return control.value === '-1' ? { error: 'El campo es requerido' } : null;
  }

}
